import FederatedPhotoError from './FederatedPhotoError';

import type { PhotoProps } from '@zg-rentals/maintenance-utils';

const Photo = ({
  id = '',
  feedId = '',
  feedListingId = '',
  rank = '',
  url = '',
  caption = '',
  thumbUrl = '',
  isAppropriate = true,
  errorDto = {},
}: Partial<PhotoProps> = {}): PhotoProps => ({
  id: String(id),
  feedId: String(feedId),
  feedListingId: String(feedListingId),
  rank: String(rank),
  url: String(url),
  caption: String(caption),
  thumbUrl: String(thumbUrl),
  isAppropriate: Boolean(isAppropriate),
  errorDto: FederatedPhotoError(errorDto),
});

export default Photo;
